import React from "react";

export type BusinessHoursMode = "business" | "extended" | "24x7";

export interface DaySchedule {
  enabled: boolean;
  start: string;
  end: string;
}

export type WeekSchedule = {
  mon: DaySchedule;
  tue: DaySchedule;
  wed: DaySchedule;
  thu: DaySchedule;
  fri: DaySchedule;
  sat: DaySchedule;
  sun: DaySchedule;
};

export interface BusinessHoursConfig {
  mode: BusinessHoursMode;
  schedule: WeekSchedule;
}

export const BUSINESS_DEFAULTS: WeekSchedule = {
  mon: { enabled: true,  start: "09:00", end: "17:00" },
  tue: { enabled: true,  start: "09:00", end: "17:00" },
  wed: { enabled: true,  start: "09:00", end: "17:00" },
  thu: { enabled: true,  start: "09:00", end: "17:00" },
  fri: { enabled: true,  start: "09:00", end: "17:00" },
  sat: { enabled: false, start: "09:00", end: "17:00" },
  sun: { enabled: false, start: "09:00", end: "17:00" },
};

export const EXTENDED_DEFAULTS: WeekSchedule = {
  mon: { enabled: true,  start: "07:00", end: "21:00" },
  tue: { enabled: true,  start: "07:00", end: "21:00" },
  wed: { enabled: true,  start: "07:00", end: "21:00" },
  thu: { enabled: true,  start: "07:00", end: "21:00" },
  fri: { enabled: true,  start: "07:00", end: "21:00" },
  sat: { enabled: true,  start: "08:00", end: "17:00" },
  sun: { enabled: false, start: "09:00", end: "17:00" },
};

const DEFAULT_CONFIG: BusinessHoursConfig = {
  mode: "business",
  schedule: BUSINESS_DEFAULTS,
};

interface BusinessHoursContextValue {
  config: BusinessHoursConfig;
  setConfig: (cfg: BusinessHoursConfig) => void;
}

const BusinessHoursContext = React.createContext<BusinessHoursContextValue>({
  config: DEFAULT_CONFIG,
  setConfig: () => {},
});

export function BusinessHoursProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = React.useState<BusinessHoursConfig>(DEFAULT_CONFIG);
  return (
    <BusinessHoursContext.Provider value={{ config, setConfig }}>
      {children}
    </BusinessHoursContext.Provider>
  );
}

export function useBusinessHours() {
  return React.useContext(BusinessHoursContext);
}

export const MODE_LABELS: Record<BusinessHoursMode, string> = {
  business: "Business Hours",
  extended: "Extended Hours",
  "24x7":   "Around the Clock",
};
